import React from 'react';
import styles from './style.module.css';

const IconLoading = () => (
  <div className={styles.spinner} />
);

export default IconLoading;
